var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof auth !== "undefined") return resolve();
	__webpack_require__.l("https://roadlab.immense.ai/auth/remoteEntry.js", function(event) {
		if(typeof auth !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "auth");
}).then(function() { return auth; });